import Blue from "~/core";

new Blue({
  name: "AlternativeParts",
  selector: ".alternative-parts-container",
  setup(container) {
    const searchInput = container.querySelector("#alternativePartsSearch");
    const partsList = container.querySelector("#alternativePartsList");

    if (!searchInput || !partsList) {
      return;
    }

    const originalItems = Array.from(
      partsList.querySelectorAll(".alternative-part-item")
    );

    const checkScrollPosition = () => {
      const isAtBottom =
        partsList.scrollTop + partsList.clientHeight >=
        partsList.scrollHeight - 1;
      if (isAtBottom) {
        container.classList.add("at-bottom");
      } else {
        container.classList.remove("at-bottom");
      }
    };

    partsList.addEventListener("scroll", checkScrollPosition);

    checkScrollPosition();

    searchInput.addEventListener("input", () => {
      const searchTerm = searchInput.value.trim().toLowerCase();

      partsList.innerHTML = "";

      let hasMatches = false;
      originalItems.forEach((item) => {
        const partText = item.textContent.toLowerCase();
        if (searchTerm === "" || partText.includes(searchTerm)) {
          const newItem = item.cloneNode(true);
          partsList.appendChild(newItem);
          hasMatches = true;
        }
      });

      if (!hasMatches && searchTerm !== "") {
        const noResultsItem = document.createElement("li");
        noResultsItem.className =
          "alternative-part-item alternative-part-item--no-results";
        noResultsItem.textContent = "No matching part numbers found.";
        partsList.appendChild(noResultsItem);
      }

      setTimeout(checkScrollPosition, 0);
    });
  },
});
